import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {FormControl, Validators} from '@angular/forms';
import { UserService } from '../../common/user.service';
import {MdSnackBar} from '@angular/material';
import { Router, ActivatedRoute, Params} from '@angular/router';
import { EventService } from '../../admin/event.service';
import { CountryService } from '../../common/country.service';
import { ActivityService } from '../../common/activity.service';
import { PackageService } from '../../common/package.service';
import { CreditService } from '../../common/credit.service';
import { PageService } from '../../common/page.service';
import {MdDialog} from '@angular/material';
import {LoginComponent} from '../../home/login/login.component';
import {TextMaskModule} from 'angular2-text-mask';
import { AppSettings } from '../../app-settings'

@Component({
  selector: 'guest-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css', '../../app.component.css'],
  providers: [ EventService, UserService, CountryService, ActivityService, PackageService, CreditService, PageService ]
})

export class GuestRegistrationComponent implements OnInit {

 CONTACT_EMAIL = AppSettings.CONTACT_EMAIL
 CONTACT_NAME = AppSettings.CONTACT_NAME

  eventId = 0;
  event: any;
  eventPages: any;
  selectedTab = 0;
  packageId = 0;
  package: any;
  currentStep = 1;
  users = [];
  countries: any;
  states: any;
 activities:any=[];
 phoneMask = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

 billingAddress = {
   name : '',
   line1 : '',
   line2 : '',
   city : '',
   stateId : '',
   state : '',
   countryId : '',
   country : '',
   zipcode : '',
   sameAsUser : false
  };
  billingStates: any;
  creditCard = {
   name : '',
   number : '',
   expMonth : '',
   expYear : '',
   cvv : '',
   type : undefined,
   save : false
  };
  regId = '';
  transactionId = '';
  spinner: boolean = false;
  payType = 'Card';
  cvvControl: any;
  packageFound: boolean = true;
  guestForm: any;
  attendeeForm: any;
  paymentForm: any;

  constructor(private eventService: EventService, private userService:  UserService, private snackBar: MdSnackBar, private activatedRoute: ActivatedRoute, private countryService: CountryService, private activityService: ActivityService, private packageService: PackageService, private router:Router, public dialog: MdDialog, private creditService: CreditService, private pageService: PageService, private titleService: Title){
  }

  ngOnInit(){
   this.initiate();
   this.titleService.setTitle('Staff / Guest Registration');
  }

  initiate(){
   this.activatedRoute.queryParams.subscribe((params: Params) => {
    this.eventId = params.eventId;
    this.packageId = params.packageId;
   });
   this.users[0] = {
    userId : '',
    firstName : '',
    lastName : '',
    email : '',
    cellPhone : '',
    password : '',
    rePassword : '',
    eventUser : {
     eventId : this.eventId,
     userId : '',
     packageId : this.packageId,
     badgeName : '',
     firstName : '',
     lastName : '',
     cellPhone : '',
     companyName : '',
     addressLine1 : '',
     addressLine2 : '',
     countryId : '',
     stateId : '',
     stateName : '',
     countryName : '',
     city : '',
     zipcode : '',
     workPhone : '',
     extension : '',
     type : 'Guest',
     designation : 'Main User',
     arriveByPlane : 0,
     arriveFlightName : '',
     arriveFlightNumber : '',
     arriveDateTime : '',
     arriveDateTime_ : new Date(),
     arriveNames : '',
     returnFlightName : '',
     returnFlightNumber : '',
     returnDateTime : '',
     returnDateTime_ : new Date(),
     returnNames : '',
     attendAwardCelebration : 0,
     userActivity : {
      userId : '',
      activityId : 0,
      transId : '123',
      questions : [],
      userQuestions : [],
      price : 0.00
     },
     price : 0.00,
     transId : '123',
     contribution : '0',
     mealRestriction : 0,
     mealChoice : 0,
     mealComments : ''
    }
   };
   this.packageService.isFound({packageId:this.packageId, eventId:this.eventId, type:'Guest'}).subscribe(response => {
    this.packageFound = response.found;
   });
   this.packageService.findPackage(this.packageId).subscribe(response => {
    this.package = response[0];
    this.users[0].eventUser.price = this.package.price;
    if(this.users.length==1)
    this.addAttendee();
   });
   this.eventService.getEvents({eventId:this.eventId}).subscribe(response => {
    this.event = response[0];
    this.event.not_started = parseInt(this.event.not_started);
    this.event.reg_ended = parseInt(this.event.reg_ended);
    this.event.obtainTravel = parseInt(this.event.obtainTravel);
    if(this.event.not_started)
    {
     this.snackBar.open('Registration not started','',{duration:4000});
     this.router.navigate(['/home']);
    }
    if(this.event.reg_ended)
    {
     this.snackBar.open('Registration ended already','',{duration:4000});
     this.router.navigate(['/home']);
    }
   });
   this.pageService.getPages(this.eventId).subscribe(response => {
    this.eventPages = response;
    var pages = [];
    for(var i=0;i<this.eventPages.length;i++)
    if((this.eventPages[i].displayFor=='Guests' || this.eventPages[i].displayFor=='Both') && this.eventPages[i].publish==1)
    pages.push(this.eventPages[i]);
    this.eventPages = pages;
    this.selectedTab = this.eventPages.length;
   });
   this.countryService.getCountries().subscribe(response => {
    this.countries = response;
    for(var i=0;i<this.countries.length;i++)
    if(this.countries[i].name=='USA')
    {
     this.users[0].eventUser.countryId = this.countries[i].id;
     this.countryChanged({apply:1});
     this.billingAddress.countryId = this.countries[i].id;
     this.billingCountryChanged();
    }
   });
   this.activityService.getActivities(this.eventId).subscribe(response => {
    this.activities = response;
    for(var i=0;i<this.activities.length;i++)
    this.activities[i].freeCount = 0;
    this.packageService.getActivityLimits({packageId:this.packageId}).subscribe(response1 => {
     for(var i=0;i<response1.length;i++)
     for(var j=0;j<this.activities.length;j++)
     if(response1[i].activityId==this.activities[j].id)
     {
      this.activities[j].freeCount = response1[i].freeCount;
      break;
     }
    });
   });
  }

  validateCvv(){
   return false;
  }

 phoneFormat(phone){
  if(phone && phone!='')
   return (phone).replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
 }

  makeCurrent(step){
   if(!this.regId)
   {
    this.currentStep = step;
    window.scrollTo(0,0);
    if(step==2 && this.users.length==1)
    this.addAttendee();
   }
  }

  register(guestForm,attendeeForm,paymentForm){
   this.spinner = true;
   if(!guestForm.valid)
   this.makeCurrent(1);
   else if(!attendeeForm.valid)
   this.makeCurrent(2);
   else if(!paymentForm.valid)
   this.makeCurrent(4);
   else
   {
    this.creditCard.type = this.cardType();
    for(var i=0;i<this.users.length;i++)
    {
     this.users[i].eventUser.arriveDateTime = this.dateTimeFormat(this.users[i].eventUser.arriveDateTime_);
     this.users[i].eventUser.returnDateTime = this.dateTimeFormat(this.users[i].eventUser.returnDateTime_);
    }
    var usrs = [this.users[0]];
    this.userService.registerGuest({ event:this.event, users:usrs.concat(this.activeUsers()), billingAddress:this.billingAddress, creditCard:this.creditCard, payTotal:this.totalFee(), payType:this.payType }).subscribe(
     response => {
      this.spinner = false;
      if(response.status)
      {
       this.snackBar.open(' Staff / Guest Registered Successfully','',{duration:4000});
       this.makeCurrent(6);
       this.regId = response.regId;
       this.transactionId = (response.transactionId && typeof(response.transactionId)=='object'?response.transactionId[0]:response.transactionId);
       this.userService.registerGuestMail({ mailData:response.mailData }).subscribe();
      }
      else
      this.snackBar.open(response.msg,'',{duration:4000});
     },
     error => {
      this.spinner = false;
      this.snackBar.open(error,'',{duration:4000});
     }
    );
   }
  }

  countryChanged(params){
   this.spinner = true;
   this.countryService.getStates(this.users[0].eventUser.countryId).subscribe(
    response => {
     this.spinner = false;
     this.states = response;
    },
    error => {
     this.spinner = false;
     this.snackBar.open(error,'',{duration:4000});
    }
   );
   if(params.apply)
   {
    for(var i=0;i<this.countries.length;i++)
    if(this.countries[i].id==this.users[0].eventUser.countryId)
    this.users[0].eventUser.countryName = this.countries[i].name;
   }
  }

  stateChanged(){
   for(var i=0;i<this.states.length;i++)
   if(this.states[i].id==this.users[0].eventUser.stateId)
   this.users[0].eventUser.stateName = this.states[i].name;
  }

  billingCountryChanged(){
   this.spinner = true;
   this.countryService.getStates(this.billingAddress.countryId).subscribe(
    response => {
     this.spinner = false;
     this.billingStates = response;
    },
    error => {
     this.spinner = false;
     this.snackBar.open(error,'',{duration:4000});
    }
   );
   for(var i=0;i<this.countries.length;i++)
   if(this.countries[i].id==this.billingAddress.countryId)
   this.billingAddress.country = this.countries[i].name;
  }

  billingStateChanged(){
   for(var i=0;i<this.billingStates.length;i++)
   if(this.billingStates[i].id==this.billingAddress.stateId)
   this.billingAddress.state = this.billingStates[i].name;
  }

  dateTimeFormat(dt){
   if(dt)
   {
    var m = dt.getMonth()+1;
    if(m<10)
    m='0'+m;
    var d = dt.getDate();
    if(d<10)
    d='0'+d;
    return dt.getFullYear()+'-'+m+'-'+d+' 00:00:00';
   }
   else
   return '';
  }

  usDateTimeFormat(dt){
   if(dt)
   {
    if(typeof dt=='string')
    {
     dt = dt.split(' ');
     dt = dt[0].split('-');
     return dt[1]+'/'+dt[2]+'/'+dt[0];
    }
    else
    {
     var m = dt.getMonth()+1;
     if(m<10)
     m='0'+m;
     var d = dt.getDate();
     if(d<10)
     d='0'+d;
     return m+'/'+d+'/'+dt.getFullYear();
    }
   }
   else
   return '';
  }

  activitySelected(userActivity){
   this.spinner = true;
   userActivity.price = 0.00;
   userActivity.userQuestions = [];
   userActivity.questions = [];
   var usedCount = 0;
   var price = 0.00;
   var freeCount = 0;
   for(var i=0;i<this.activities.length;i++)
   if(this.activities[i].id==userActivity.activityId)
   {
    userActivity.activityName = this.activities[i].name;
    price = parseFloat(this.activities[i].price);
    freeCount = this.activities[i].freeCount;
    break;
   }
   for(var i=0;i<this.users.length;i++)
   {
    if(this.users[i].eventUser.userActivity.activityId==userActivity.activityId)
    usedCount+=1;
    if(usedCount>freeCount)
    userActivity.price = price;
   }
   this.activityService.getActivityQuestionsWithOptions({activityId:userActivity.activityId}).subscribe(
    response => {
     this.spinner = false;
     userActivity.questions = response;
     userActivity.userQuestions = [];
     for(var i=0;i<userActivity.questions.length;i++)
     {
      userActivity.questions[i].isMandatory = parseInt(userActivity.questions[i].isMandatory);
      userActivity.userQuestions.push({id:'', userId:userActivity.userId, questionId:userActivity.questions[i].id, answerId:0, answerText:'', transId:'123', price:0});
      for(var j=0;j<userActivity.questions[i].options.length;j++)
      {
       userActivity.questions[i].options[j].isPrice = parseInt(userActivity.questions[i].options[j].isPrice);
       for(var k=0;k<userActivity.questions[i].options[j].questions.length;k++)
       {
	userActivity.questions[i].options[j].questions[k].isMandatory = parseInt(userActivity.questions[i].options[j].questions[k].isMandatory);
        for(var l=0;l<userActivity.questions[i].options[j].questions[k].options.length;l++)
        userActivity.questions[i].options[j].questions[k].options[l].isPrice = parseInt(userActivity.questions[i].options[j].questions[k].options[l].isPrice);
       }
      }
     }
    },
    error => {
     this.spinner = false;
    }
   );
  }

  optionSelected(params){
   for(var i=0;i<params.question.options.length;i++)
   {
    if(params.question.options[i].id==params.optionId && (params.userActivity.userQuestions[params.questionIndex].answerId==params.optionId || params.question.options[i].selected))
    {
     params.question.options[i].userQuestions = [];
     for(var j=0;j<params.question.options[i].questions.length;j++)
     params.question.options[i].userQuestions.push({id:'', userId:params.userActivity.userId, questionId:params.question.options[i].questions[j].id, answerId:0, answerText:'', transId:'123', price:0});
    }
   }
   if(params.userActivity.price)
   this.setPrice(params);
  }

  setPrice(params){
   params.userActivity.userQuestions[params.questionIndex].price = 0.00;
   for(var i=0;i<params.question.options.length;i++)
   {
    for(var j=0;j<params.question.options[i].userQuestions.length;j++)
    params.question.options[i].userQuestions[j].price = 0.00;
    if(params.userActivity.userQuestions[params.questionIndex].answerId==params.question.options[i].id || params.question.options[i].selected)
    {
     if(params.question.options[i].isPrice)
     {
      if(params.question.answerType=='Radio')
      params.userActivity.userQuestions[params.questionIndex].price = parseFloat(params.question.options[i].price);
      else if(params.question.answerType=='Check')
      params.userActivity.userQuestions[params.questionIndex].price += parseFloat(params.question.options[i].price);
     }
    }
   }
  }

  subOptionSelected(params){
   if(params.userActivity.price)
   this.setSubPrice(params)
  }

  setSubPrice(params){
   params.option.userQuestions[params.questionIndex].price = 0.00;
   for(var i=0;i<params.question.options.length;i++)
   {
    if(params.option.userQuestions[params.questionIndex].answerId==params.question.options[i].id || params.question.options[i].selected)
    {
     if(params.question.options[i].isPrice)
     {
      if(params.question.answerType=='Radio')
      params.option.userQuestions[params.questionIndex].price = parseFloat(params.question.options[i].price);
      else if(params.question.answerType=='Check')
      params.option.userQuestions[params.questionIndex].price += parseFloat(params.question.options[i].price);
     }
    }
   }
  }

  attendees(){
   var attendees = [];
   for(var i=1;i<this.users.length;i++)
   attendees.push(this.users[i]);
   return attendees;
  }

  addAttendee(){
   this.users.push({
    userId : '',
    firstName : '',
    lastName : '',
    email : '',
    cellPhone : '',
    password : '',
    rePassword : '',
    eventUser : {
     eventId : this.eventId,
     userId : '',
     packageId : this.packageId,
     badgeName : '',
     firstName : '',
     lastName : '',
     cellPhone : '',
     companyName : '',
     addressLine1 : '',
     addressLine2 : '',
     countryId : '',
     stateId : '',
     city : '',
     zipcode : '',
     workPhone : '',
     extension : '',
     type : 'Guest',
     designation : 'Business Attendee',
     arriveByPlane : 0,
     arriveFlightName : '',
     arriveFlightNumber : '',
     arriveDateTime : '',
     arriveDateTime_ : new Date(),
     arriveNames : '',
     returnFlightName : '',
     returnFlightNumber : '',
     returnDateTime : '',
     returnDateTime_ : new Date(),
     returnNames : '',
     attendAwardCelebration : 0,
     userActivity : {
      userId : '',
      activityId : 0,
      transId : '123',
      questions : [],
      userQuestions : [],
      price : 0.00
     },
     price : this.package.extraAttendeePrice,
     mealRestriction : 0,
     mealChoice : 0,
     mealComments : ''
    }
   });
  }

  deleteUser(i){
   if(confirm('Are you sure?'))
   {
    //this.users.splice(i,1);
    this.users[i].deleted = true;
    //this.checkUserPrice();
    //this.checkActivityPrice();
   }
  }

  checkUserPrice(){
   var usrCnt = 0;
   for(var i=1;i<this.users.length;i++)
   {
    if(!this.users[i].deleted)
    usrCnt += 1;
    if(usrCnt>=this.package.freeAttendeesCount)
    this.users[i].eventUser.price = this.package.extraAttendeePrice;
    else
    this.users[i].eventUser.price = 0.00;
   }
  }

  checkActivityPrice(){
   /*for(var i=0;i<this.users.length;i++)
   {
    if(this.users[i].deleted)
    continue;
    var usedCount = 0;
    var price = 0.00;
    var freeCount = 0;
    for(var j=0;j<this.activities.length;j++)
    {
     if(this.activities[j].id==this.users[i].eventUser.userActivity.activityId)
     {
      this.users[i].eventUser.userActivity.activityName = this.activities[j].name;
      price = parseFloat(this.activities[j].price);
      freeCount = this.activities[j].freeCount;
      break;
     }
    }
    for(var j=0;j<=i;j++)
    {
     if(!this.users[j].deleted && this.users[i].eventUser.userActivity.activityId==this.users[j].eventUser.userActivity.activityId)
     usedCount+=1;
    }
    if(usedCount>freeCount)
    this.users[i].eventUser.userActivity.price = price;
    else
    {
     this.users[i].eventUser.userActivity.price = 0.00;
     for(var j=0;j<this.users[i].eventUser.userActivity.userQuestions.length;j++)
     {
      this.users[i].eventUser.userActivity.userQuestions[j].price = 0.00;
      for(var k=0;k<this.users[i].eventUser.userActivity.questions[j].options.length;k++)
      for(var l=0;l<this.users[i].eventUser.userActivity.questions[j].options[k].userQuestions.length;l++)
      this.users[i].eventUser.userActivity.questions[j].options[k].userQuestions[l].price = 0.00;
     }
    }
   }*/
  }

  notValid(frm){
  }

  userFee(i){
   var price = parseFloat(this.users[i].eventUser.price);
   price += parseFloat(this.activityFee(i));
   return price;
  }

  activityFee(i){
   if(!this.users[i] || !this.activities)
   return '0.00';
   var price = parseFloat(this.users[i].eventUser.userActivity.price);
   for(var i1=0;i1<this.users[i].eventUser.userActivity.userQuestions.length;i1++)
   {
    price += parseFloat(this.users[i].eventUser.userActivity.userQuestions[i1].price);
    for(var j=0;j<this.users[i].eventUser.userActivity.questions[i1].options.length;j++)
    {
     for(var k=0;k<this.users[i].eventUser.userActivity.questions[i1].options[j].userQuestions.length;k++)
     price += parseFloat(this.users[i].eventUser.userActivity.questions[i1].options[j].userQuestions[k].price);
    }
   }
   this.users[i].eventUser.userActivity.totalPrice = price;
   return price.toFixed(2);
  }

  totalFee(){
   var price = 0.00;
   for(var i=0;i<this.users.length;i++)
   if(!this.users[i].deleted)
   price += this.userFee(i);
   if(!isNaN(parseFloat(this.users[0].eventUser.contribution)))
   price += parseFloat(this.users[0].eventUser.contribution);
   this.users[0].eventUser.totalPrice = price;
   return price.toFixed(2);
  }

  subTotal(){
   var subTotal = parseFloat(this.totalFee())-(!isNaN(parseFloat(this.users[0].eventUser.contribution)) ? parseFloat(this.users[0].eventUser.contribution) : 0);
   return subTotal.toFixed(2);
  }

  billingSameAsUser(){
   this.spinner = true;
   if(this.billingAddress.sameAsUser)
   {
    this.billingAddress.name = this.users[0].eventUser.companyName;
    this.billingAddress.line1 = this.users[0].eventUser.addressLine1;
    this.billingAddress.line2 = this.users[0].eventUser.addressLine2;
    this.billingAddress.city = this.users[0].eventUser.city;
    this.billingAddress.stateId = this.users[0].eventUser.stateId;
    this.billingAddress.state = this.users[0].eventUser.stateName;
    this.billingAddress.countryId = this.users[0].eventUser.countryId;
    this.countryService.getStates(this.users[0].eventUser.countryId).subscribe(
     response => {
      this.spinner = false;
      this.billingStates = response;
     },
     error => {
      this.spinner = false;
     }
    );
    this.billingAddress.country  = this.users[0].eventUser.countryName;
    this.billingAddress.zipcode = this.users[0].eventUser.zipcode;
   }
   else
   {
    this.spinner = false;
    this.billingAddress.name = '';
    this.billingAddress.line1 = '';
    this.billingAddress.line2 = '';
    this.billingAddress.city = '';
    this.billingAddress.stateId = '';
    this.billingAddress.state = '';
    this.billingAddress.countryId = '';
    this.billingAddress.country = '';
    this.billingAddress.zipcode = '';
   }
  }

  skipAttendees(){
   this.users.splice(1);
   this.makeCurrent(3);
  }

  print(){
   window.print();
  }

  loginDialog() {
    let dialogRef = this.dialog.open(LoginComponent);
    dialogRef.componentInstance.onLogin.subscribe(() => {
     dialogRef.close();
    });
  }

  cardType(){
   return this.creditService.parseCardType(this.creditCard.number);
  }

  guestFormValid(frm){
   var flag = true;
   if(!frm.valid)
   flag = false;
   if(flag && this.users[0].password!=this.users[0].rePassword)
   flag = false;
   if(flag && !this.validateEmail(this.users[0].email))
   flag = false;
   if(flag && !this.validatePhone(this.users[0].eventUser.cellPhone))
   flag = false;
   if(flag && !this.validateZip(this.users[0].eventUser.zipcode,this.users[0].eventUser.countryName))
   flag = false;
   if(flag)
   {
    for(var i=0;i<this.users[0].eventUser.userActivity.questions.length;i++)
    {
     if(!flag)
     break;
     if(this.users[0].eventUser.userActivity.questions[i].isMandatory==1 && (this.users[0].eventUser.userActivity.questions[i].answerType=='TextField' || this.users[0].eventUser.userActivity.questions[i].answerType=='Radio') && !(this.users[0].eventUser.userActivity.userQuestions[i].answerText || this.users[0].eventUser.userActivity.userQuestions[i].answerId>0))
     flag = false;
     for(var j=0;j<this.users[0].eventUser.userActivity.questions[i].options.length;j++)
     {
      if(!flag)
      break;
      if(this.users[0].eventUser.userActivity.questions[i].options[j].id!=this.users[0].eventUser.userActivity.userQuestions[i].answerId)
      continue;
      for(var k=0;k<this.users[0].eventUser.userActivity.questions[i].options[j].questions.length;k++)
      {
       if(!flag)
       break;
       if(!this.users[0].eventUser.userActivity.questions[i].options[j].userQuestions[k])
       continue;
       if(this.users[0].eventUser.userActivity.questions[i].options[j].questions[k].isMandatory==1 && (this.users[0].eventUser.userActivity.questions[i].options[j].questions[k].answerType=='TextField' || this.users[0].eventUser.userActivity.questions[i].options[j].questions[k].answerType=='Radio') && !(this.users[0].eventUser.userActivity.questions[i].options[j].userQuestions[k].answerText || this.users[0].eventUser.userActivity.questions[i].options[j].userQuestions[k].answerId>0))
       flag = false;
      }
     }
    }
   }
   if(flag==false){
    const firstElementWithError = document.querySelector('.ng-invalid');
    if (firstElementWithError) {
     firstElementWithError.scrollIntoView({ behavior: 'smooth' });
    }
    this.snackBar.open('You are missing some required information. Please fill and submit.',' ',{ duration: 4000 });
   }
   return flag;
  }

  attendeeFormValid(frm){
   var flag = true;
   if(!frm.valid)
   flag = false;
   for(var i=1;i<this.users.length;i++)
   {
    if(this.users[i].deleted)
    continue;
    if(flag && this.users[i].password!=this.users[i].rePassword)
    {
     flag = false;
     break;
    }
    if(flag && this.users[i].email && !this.validateEmail(this.users[i].email))
    {
     flag = false;
     break;
    }
    if(flag && this.users[i].eventUser.cellPhone && !this.validatePhone(this.users[i].eventUser.cellPhone))
    {
     flag = false;
     break;
    }
    if(flag)
    {
     for(var j=0;j<this.users[i].eventUser.userActivity.questions.length;j++)
     {
      if(!flag)
      break;
      if(this.users[i].eventUser.userActivity.questions[j].isMandatory==1 && (this.users[i].eventUser.userActivity.questions[j].answerType=='TextField' || this.users[i].eventUser.userActivity.questions[j].answerType=='Radio') && !(this.users[i].eventUser.userActivity.userQuestions[j].answerText || this.users[i].eventUser.userActivity.userQuestions[j].answerId>0))
      flag = false;
      for(var k=0;k<this.users[i].eventUser.userActivity.questions[j].options.length;k++)
      {
       if(!flag)
       break;
       if(this.users[i].eventUser.userActivity.questions[j].options[k].id!=this.users[i].eventUser.userActivity.userQuestions[j].answerId)
       continue;
       for(var l=0;l<this.users[i].eventUser.userActivity.questions[j].options[k].questions.length;l++)
       {
        if(!flag)
        break;
        if(!this.users[i].eventUser.userActivity.questions[j].options[k].userQuestions[l])
        continue;
        if(this.users[i].eventUser.userActivity.questions[j].options[k].questions[l].isMandatory==1 && (this.users[i].eventUser.userActivity.questions[j].options[k].questions[l].answerType=='TextField' || this.users[i].eventUser.userActivity.questions[j].options[k].questions[l].answerType=='Radio') && !(this.users[i].eventUser.userActivity.questions[j].options[k].userQuestions[l].answerText || this.users[i].eventUser.userActivity.questions[j].options[k].userQuestions[l].answerId>0))
        flag = false;
       }
      }
     }
    }
   }
   if(flag==false){
    const firstElementWithError = document.querySelector('.ng-invalid');
    if (firstElementWithError) {
     firstElementWithError.scrollIntoView({ behavior: 'smooth' });
    }
    this.snackBar.open('You are missing some required information. Please fill and submit.',' ',{ duration: 4000 });
   }
   return flag;
  }

  paymentFormValid(frm){
   var flag = true;
   if(!frm.valid)
   flag = false;
   if(this.payType=='Card')
   {
    if(flag && !this.validateDigit(this.creditCard.number,14,19))
    flag = false;
    if(flag && !this.validateDigit(this.creditCard.expMonth,2,2))
    flag = false;
    if(flag && !this.validateDigit(this.creditCard.expYear,2,2))
    flag = false;
    if(flag && !this.validateDigit(this.creditCard.cvv,3,4))
    flag = false;
   }
   if(flag==false){
    const firstElementWithError = document.querySelector('.ng-invalid');
    if (firstElementWithError) {
     firstElementWithError.scrollIntoView({ behavior: 'smooth' });
    }
    this.snackBar.open('You are missing some required information. Please fill and submit.',' ',{ duration: 4000 });
   }
   return flag;
  }

  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  validatePhone(phone){
   var re = /^[0-9]{10}$/;
   return re.test(phone.replace(/-/g, ""));
  }

  validateZip(zip,country){
    return true;
  //  if(country=='Canada')
  //  var re = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
  //  else
  //  var re = /^\d{5}(-\d{4})?$/;
  //  return re.test(zip);
  }

  validateDigit(num,min,max){
   return num.match("^[0-9]{"+min+","+max+"}$");
  }

  negativeCheck(){
   if(isNaN(this.users[0].eventUser.contribution) || parseFloat(this.users[0].eventUser.contribution)<0)
   this.users[0].eventUser.contribution = 0;
  }

  tabChanged($event: any, guestForm, attendeeForm, paymentForm){
   if($event.tab.textLabel!='Registration Form')
   this.resetPage(guestForm, attendeeForm, paymentForm);
  }

  resetPage(guestForm,attendeeForm,paymentForm){
   this.users = [];
   this.regId = '';
   this.transactionId = '';
   this.payType = 'Card';
   this.activities = []
   this.makeCurrent(1);
   this.billingAddress = {
    name : '',
    line1 : '',
    line2 : '',
    city : '',
    stateId : '',
    state : '',
    countryId : '',
    country : '',
    zipcode : '',
    sameAsUser : false
   };
   this.billingStates = []
   this.creditCard = {
    name : '',
    number : '',
    expMonth : '',
    expYear : '',
    cvv : '',
    type : undefined,
    save : false
   };
   this.initiate();
  }

  activeUsers(){
   var u = [];
   for(var i=1;i<this.users.length;i++)
   if(!this.users[i].deleted)
   u.push(this.users[i]);
   return u;
  }

  activeIndex(index){
   var indx = 0;
   for(var i=0;i<index;i++)
   if(!this.users[i].deleted)
   indx += 1;
   return indx;
  }

  triggerClick(id){
   (<HTMLInputElement>window.document.getElementById(id)).click()
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/guest/registration/registration.component.ts